import type { PKGNodeEntityType, PKGEdgeType, LayoutHint } from '@blueprint/shared';

// PKGV.B2 (#796) — canonical query-state shape (V2 adjudication,
// Sprint-B2-adjudication.md). One object, written by the sidebar filter
// UI, read by the subgraph fetch, and persisted verbatim by "save as
// bookmark" — filters/fetch/save cannot drift from each other by
// construction, since there's only one shape between them (the
// structural answer to §8 adversarial item 2: filter->param fidelity).
//
// Mirrors PkgBookmarkQueryParams (apps/api/src/db/schema/
// user-pkg-bookmarks.ts) field-for-field. `depth` is deliberately not
// part of this shape — every view this cut is anchor-less (Q9), and
// depth is a no-op without anchorIds (B1 contract).
export interface ExplorerQueryState {
  nodeTypes?: PKGNodeEntityType[];
  edgeTypes?: PKGEdgeType[];
  anchorIds?: string[];
  layoutHint: LayoutHint;
}

// Q9 adjudicated default seed: anchor-less, decision/risk/requirement.
export const DEFAULT_QUERY_STATE: ExplorerQueryState = {
  nodeTypes: ['decision', 'risk', 'requirement'],
  layoutHint: 'dagre',
};
